import { mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";

import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { FETCH_USER_STATIONS_URL } from "../../../const/common/endpoints";
import {
  LoadUserStations,
  StoreUserStations,
} from "../../actions/common/actionCreators";
import { AJAX_HEADER_JSON } from "../../../const/common/ajaxConsts";
import { ESMTasks } from "../../../const/esm/ESMTaskConsts";

export const DEFAULT_VAL = ESMTasks.SearchSpec;

export const userStationsEpic = action$ =>
  action$.pipe(
    ofType(LoadUserStations.REQUEST().type),
    mergeMap(val =>
      ajax
        .post(
          FETCH_USER_STATIONS_URL,
          {
            TaskName: val.payload?.taskName
              ? val.payload.taskName
              : DEFAULT_VAL,
            notInCode: val.payload?.notInCode,
          },
          {
            ...AJAX_HEADER_JSON,
          }
        )
        .pipe(
          mergeMap(xhrResponse => {
            return of(
              LoadUserStations.SUCCESS(),
              StoreUserStations.PUT_USER_STATIONS(xhrResponse.response)
            );
          }),
          catchError(error => {
            console.log(error);
            return of(LoadUserStations.FAILURE());
          })
        )
    )
  );
